import React from 'react';
import moment from 'moment';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material';

import {
  Plagiarism,
  PropaneTank,
  WorkHistory
} from '@mui/icons-material';
import { Eye, EyeSlash, FileArrowUpFill } from 'react-bootstrap-icons';

import API from '../../data/api';
// import GlobalFilter from '../global-filter/GlobalFilter'; // Import GlobalFilter
import CustomTablePagination from '../custom/CustomTablePagination';
import palette from '../../theme/palette';
import { OrderAllocationSummary } from './modals/OrderAllocationSummary';
import { isNotNullValue, isNullValue } from '../../utils/formUtil';
import { isAuthorizedRole } from '../../utils/authUtil';
import OrderDepotTankTransfer from './modals/OrderDepotTankTransfer';
import FinanceDocumentUpload from './modals/FinanceDocumentUpload';
import { nestedTableStyle } from '../../utils/constants';
import DocumentViewer from '../ui/DocumentViewer';

export default class DeliveredOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveredOrdersList: [],
      page: 1,
      records: 15,
      totalRecords: 1,
      totalPages: null,
      recordsList: [5, 10, 15, 20],
      selectedOrder: null,
      viewAllocationSummary: false,
      depots: [],
      openDepotTankAllocation: false,
      expandedRow: null,
      pdfModalOpen: false,
      pdfUrl: '',
    };
  }

  componentDidMount() {
    this.loadRefreshData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.filterString !== this.props.filterString) {
      this.loadRefreshData();
    }
  }

  loadRefreshData = async () => {
    this.getDeliveredOrders(this.props.filterString);
    this.getDepots();
  }

  getDeliveredOrders = async (finalQuery = '') => {
    const { records, page } = this.state;
    let conTemp = `inventory/backoffice/delivered_suborders?records=${records}&page=${page}`;
    if (finalQuery) {
      conTemp += finalQuery;
    }

    try {
      const res = await API.get(conTemp);
      if (res.status === 200) {
        const suborders = res.data.suborders;
        this.setState({
          deliveredOrdersList: suborders,
          totalPages: res.data.total_pages,
          totalRecords: res.data.total_suborders,
        });
      } else {
        console.error("Error fetching delivered orders:", res.status);
      }
    } catch (error) {
      console.error("Error fetching delivered orders:", error);
    }
  }

  getDepots = async () => {
    try {
      const response = await API.get('inventory/backoffice/depots?depot_type=storage');
      if (response.status === 200) {
        this.setState({ depots: response.data.depots });
      } else {
        console.error('Error fetching depots: ', response.status);
      }
    } catch (error) {
      console.error('Error fetching depots: ', error);
    }
  };

  getSubOrders = async (suborderId) => {
    try {
      const response = await API.get(`inventory/backoffice/suborders/${suborderId}`);
      if (response.status === 200) {
        const { documents } = response.data;

        this.setState((prevState) => ({
          orderDocuments: documents || [],
        }));
        console.log("suborders ", response)
      } else {
        console.error('Error fetching suborders:', response.status);
      }
    } catch (error) {
      console.error('Error fetching suborders:', error);
    }
  };

  handleViewAllocationSummary = (subOrder = null) => {
    this.setState({
      viewAllocationSummary: isNotNullValue(subOrder),
      selectedOrder: subOrder,
    });

  };

  handleDepotTankAllocation = (subOrder = null) => {
    this.setState({
      openDepotTankAllocation: isNotNullValue(subOrder),
      selectedOrder: subOrder,
    });

  };

  handleViewOrderDocuments = async (orderItem) => {

    if (this.state.expandedRow?.suborder_id === orderItem?.suborder_id) {
      this.setState({ expandedRow: null });
    } else {
      this.setState({ expandedRow: orderItem });
      this.getSubOrders(orderItem?.suborder_id);
    }
  };

  toggleInvoiceUploadModal = ({ order = null, updateStats = false, isOpen = false, isTaxInvoice = true }) => {

    if (updateStats) {
      const _suborder = this.state?.processedOrder?.orderItem;
      this.getDeliveredOrders(this.props.filterString);
      this.handleViewOrderDocuments(_suborder);
    }

    this.setState({
      processedOrder: {
        openModal: isOpen,
        orderItem: isNotNullValue(order) ? { ...order, order_item_id: order.suborder_id } : null,
        isTaxInvoice: isTaxInvoice,
      },
    });
  };

  handleOpenDocumentViewer = async (url=null) => {
    this.setState({
      pdfModalOpen: isNotNullValue(url),
      pdfUrl: url,
    });
  };

  nextPage = (action) => {
    const limit = this.state.totalPages;
    this.setState((prevState) => {
      let currentPage = prevState.page;

      if (action === 'next') {
        currentPage = Math.min(currentPage + 1, limit);
      } else {
        currentPage = Math.max(currentPage - 1, 1);
      }

      return { page: currentPage };
    }, () => {
      this.getDeliveredOrders(this.props.filterString);
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState(() => {
      return { records: parseInt(event.target.value, 10), page: 1 };
    }, () => {
      this.getDeliveredOrders(this.props.filterString);
    });
  }

  render() {
    return (
      <Paper>
        {/* <GlobalFilter sx={{ my: 1 }} onFilterChange={this.handleFilterChange} /> */}

        <TableContainer  sx={{ mt: 2, width: '100%', overflowX: { xs: 'scroll', sm: 'auto' } }} >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Order Number</TableCell>
              <TableCell align="right">Client Name</TableCell>
              <TableCell align="right">Product</TableCell>
              <TableCell align="right">Volume</TableCell>
              <TableCell align="right">Delivery Location</TableCell>
              <TableCell align="center">Created Date</TableCell>
              <TableCell align="right">Scheduled Delivery Date</TableCell>
              {isAuthorizedRole(["LOGISTICS-C2"]) && (
                <TableCell align="right">Actions</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.deliveredOrdersList.map((row) => (<>
              <TableRow
                key={row.suborder_id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: 'rgba(39,226,245,0.27)' } }}>
                <TableCell component="th" scope="row">{row.suborder_id}</TableCell>
                <TableCell align="right">{row.company_name}</TableCell>
                <TableCell align="right">{row.fuel_type}</TableCell>
                <TableCell align="right">{row.volume}</TableCell>
                <TableCell align="right">{row.delivery_location}</TableCell>
                <TableCell align="right">{moment(row.created_datetime).format('YYYY/MM/DD - HH:mm:ss')}</TableCell>
                <TableCell align="right">{moment(row.delivery_scheduled_datetime).format('YYYY/MM/DD - HH:mm:ss')}</TableCell>
                {isAuthorizedRole(["LOGISTICS-C2"]) && (
                  <TableCell align="right">
                    {(row?.delivery_note_flag || row?.invoice_flag) && (
                      <>
                        {this.state.expandedRow?.suborder_id === row.suborder_id ? (
                          <Tooltip title={`Hide Order Documents`}>
                            <IconButton onClick={() => this.handleViewOrderDocuments(row)}>
                              <EyeSlash color={palette.info.main} />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title={`View Order Documents`}>
                            <IconButton onClick={() => this.handleViewOrderDocuments(row)}>
                              <Eye color={palette.info.main} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </>
                    )}
                    <Tooltip title={`${row?.delivery_note_flag ? 'Re-Upload' : 'Upload'} Delivery Note`}>
                      <IconButton onClick={() => this.toggleInvoiceUploadModal({ order: row, isOpen: true, isTaxInvoice: false })}>
                        <FileArrowUpFill color={`${row?.delivery_note_flag ? palette.success.main : palette.info.main}`} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Order Summary">
                      <IconButton onClick={() => this.handleViewAllocationSummary(row)}>
                        <WorkHistory color={palette.warning.main} />
                      </IconButton>
                    </Tooltip>
                    {isNullValue(row?.allocated_to) && (
                      <Tooltip title="Product Allocation">
                        <IconButton onClick={() => this.handleDepotTankAllocation(row)}>
                          <PropaneTank color='success' />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                )}
              </TableRow>
              {(this.state.expandedRow?.suborder_id === row.suborder_id
                && isAuthorizedRole(["LOGISTICS-C2"])) && (
                  <TableRow
                    sx={{ ...nestedTableStyle }}
                    selected={this.state.expandedRow?.suborder_id === row.suborder_id}
                  >
                    <TableCell
                      colSpan={9}
                    >
                      <TableContainer sx={{ mt: 2, width: '100%', overflowX: { xs: 'scroll', sm: 'auto', } }} >
                        <Table size="small" aria-label="suborders">
                          <TableHead>
                            <TableRow>
                              <TableCell>Document Name</TableCell>
                              <TableCell>Document Number</TableCell>
                              <TableCell>Date Time</TableCell>
                              <TableCell>Net Price</TableCell>
                              <TableCell align="right">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.orderDocuments?.map((docRow) => (
                              <TableRow
                                key={docRow?.document_id}
                                sx={{ backgroundColor: '#FFFAFA' }}
                                selected={this.state.currentSubOrder === docRow.suborder_id}
                              >
                                <TableCell>{docRow.file_name}</TableCell>
                                <TableCell>{docRow.document_number}</TableCell>
                                <TableCell>
                                  {moment(docRow?.created_datetime || null).format('YYYY/MM/DD - HH:mm:ss')}
                                </TableCell>
                                <TableCell>{docRow?.net_price}</TableCell>
                                <TableCell align='right'>
                                  <Tooltip title="Open Document">
                                    <IconButton onClick={() => this.handleOpenDocumentViewer(docRow?.file_url)}>
                                      <Plagiarism color='info' />
                                    </IconButton>
                                  </Tooltip>
                                  {/* <IconButton onClick={() => console.log('edit', docRow)}>
                                        <Pencil color={palette.info.main} />
                                      </IconButton>
                                      <IconButton onClick={() => console.log('delete', docRow)}>
                                        <TrashFill color={palette.error.main} />
                                      </IconButton> */}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TableCell>
                  </TableRow>
                )}
            </>))}
          </TableBody>
        </Table>
        </TableContainer>

        <CustomTablePagination
          rowsPerPage={this.state.records}
          recordsList={this.state.recordsList}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
          handleNextPage={this.nextPage.bind(this)}
          currentPage={this.state.page}
          totalPages={this.state.totalPages}
        />

        <OrderAllocationSummary
          orderData={this.state.selectedOrder}
          handleCloseModal={() => this.handleViewAllocationSummary(null)}
          openModal={this.state.viewAllocationSummary}
          isBulk
        />

        <OrderDepotTankTransfer
          orderData={this.state.selectedOrder}
          depots={this.state.depots}
          openModal={this.state.openDepotTankAllocation}
          handleCloseModal={() => this.handleDepotTankAllocation(null)}
          handleSubmitCallback={() => {
            this.handleDepotTankAllocation(null);
            this.loadRefreshData();
          }}
        />

        <FinanceDocumentUpload
          handleCloseModal={this.toggleInvoiceUploadModal}
          processedOrder={this.state.processedOrder}
        />

        <DocumentViewer
          documentUrl={this.state.pdfUrl}
          openModal={this.state.pdfModalOpen}
          handleCloseModal={() => this.handleOpenDocumentViewer(null)}
        />
      </Paper>
    );
  }
}
